import React, { useState } from 'react';
import { Send } from 'lucide-react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Navbar from '../components/accueil/Navbar';
import PageBanner from './Banner';
import Footer from '../components/accueil/Footer';
import ChatWidget from '../components/accueil/ChatWidget';
import useGlobale from '../components/global';

const ContactScreen = () => {
  const { authenticated, user, logout } = useGlobale();
  const [formData, setFormData] = useState({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        objet: '',
        message: ''
      });
      const [isLoading, setIsLoading] = useState(false);
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
          await new Promise(resolve => setTimeout(resolve, 1500));
          setFormData({ 
            nom: '', prenom: '', email: '', telephone: '', objet: '', message: '' 
          });
        } catch (error) {
          console.error('Erreur:', error);
        } finally {
          setIsLoading(false);
        }
      };
    
      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
  
    return (
      <>
        <Navbar authenticated={authenticated} user={user} logout={logout} />
        <PageBanner currentPage="Contact" />
        <div className="min-h-[calc(100vh-450px)] flex items-center justify-center bg-gray-50 py-8">
          <div className="max-w-3xl w-full mx-4 bg-white p-8 rounded-2xl shadow-xl">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
              Formulaire de Contact
            </h2>
            <p className="text-sm text-gray-600 mb-8 text-center">
              Les champs marqués d'un <span className="text-red-500">*</span> sont obligatoires
            </p>
  
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Nom et Prénom */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Nom */}
                <div>
                  <label htmlFor="nom" className="text-sm font-medium text-gray-700 block mb-2">
                    Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    required
                    className="block w-full px-4 py-3 border border-gray-300 rounded-xl 
                              focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                              transition-all duration-200 ease-in-out text-base"
                    placeholder="Votre nom"
                  />
                </div>
  
                {/* Prénom */}
                <div>
                  <label htmlFor="prenom" className="text-sm font-medium text-gray-700 block mb-2">
                    Prénom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    required
                    className="block w-full px-4 py-3 border border-gray-300 rounded-xl 
                              focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                              transition-all duration-200 ease-in-out text-base"
                    placeholder="Votre prénom"
                  />
                </div>
              </div>
  
              {/* Email et Téléphone */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Email */}
                <div>
                  <label htmlFor="email" className="text-sm font-medium text-gray-700 block mb-2">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="block w-full px-4 py-3 border border-gray-300 rounded-xl 
                              focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                              transition-all duration-200 ease-in-out text-base"
                    placeholder="exemple@email.com"
                  />
                </div>
  
                {/* Téléphone */}
                <div>
                  <label htmlFor="telephone" className="text-sm font-medium text-gray-700 block mb-2">
                    Téléphone <span className="text-red-500">*</span>
                  </label>
                  <PhoneInput
                    country={'ne'}
                    value={formData.telephone}
                    onChange={phone => setFormData({ ...formData, telephone: phone })}
                    inputProps={{
                      required: true,
                      name: 'telephone',
                    }}
                    preferredCountries={['ne', 'bj', 'bf', 'ml', 'ng', 'td', 'dz', 'ly']}
                    enableSearch={true}
                    searchPlaceholder="Rechercher un pays..."
                    searchNotFound="Pays non trouvé"
                    containerClass="!w-full"
                    inputClass="!w-full !h-[46px] !text-base"
                    buttonClass="!h-[46px]"
                  />
                </div>
              </div>
  
              {/* Objet (optionnel) */}
              <div>
                <label htmlFor="objet" className="text-sm font-medium text-gray-700 block mb-2">
                  Objet <span className="text-gray-400">(optionnel)</span>
                </label>
                <input
                  type="text"
                  id="objet"
                  name="objet"
                  value={formData.objet}
                  onChange={handleChange}
                  className="block w-full px-4 py-3 border border-gray-300 rounded-xl 
                            focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                            transition-all duration-200 ease-in-out text-base"
                  placeholder="Objet de votre message"
                />
              </div>
  
              {/* Message */}
              <div>
                <label htmlFor="message" className="text-sm font-medium text-gray-700 block mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="block w-full px-4 py-3 border border-gray-300 rounded-xl 
                            focus:ring-2 focus:ring-brand-500 focus:border-brand-500
                            transition-all duration-200 ease-in-out text-base resize-none"
                  placeholder="Votre message..."
                />
              </div>
  
              {/* Bouton Envoyer */}
              <div className="pt-4">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full flex justify-center items-center space-x-2 py-3 px-6
                            border border-transparent rounded-xl text-white 
                            bg-brand-600 hover:bg-brand-700 
                            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500
                            transition-all duration-200 ease-in-out
                            font-medium text-base
                            ${isLoading ? 'opacity-80 cursor-not-allowed' : ''}`}
                >
                  {isLoading ? (
                    <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <>
                      <Send className="h-5 w-5" />
                      <span>Envoyer le message</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <Footer />
        <ChatWidget />
  
        {/* Style pour le téléphone reste le même */}
        <style jsx global>{`
          .react-tel-input .form-control {
            width: 100% !important;
            height: 46px !important;
            border-radius: 0.75rem !important;
            font-size: 1rem !important;
          }
          .react-tel-input .flag-dropdown {
            border-radius: 0.75rem 0 0 0.75rem !important;
          }
          .react-tel-input .selected-flag {
            border-radius: 0.75rem 0 0 0.75rem !important;
          }
        `}</style>
      </>
    );
  };
  
  export default ContactScreen;